import { Link } from "react-router-dom";
import { ShieldCheck, Lock, FileText, Mail, Database, Trash2, Award } from "lucide-react";

export default function Confidentialite() {
  return (
    <main className="min-h-screen bg-white text-slate-900" data-testid="page-confidentialite">
      <section className="bg-gradient-to-b from-[#0F172A] to-[#0B1220] text-white pt-40 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#10B981]/25 bg-[#10B981]/[0.06] px-3 py-1.5 mb-5">
            <Lock className="h-3.5 w-3.5 text-[#10B981]" />
            <span className="text-[10px] uppercase tracking-[0.28em] text-[#10B981] font-bold">Protection des données</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
            Politique de confidentialité
          </h1>
          <p className="mt-5 text-white/70 text-base sm:text-lg leading-relaxed">
            ECONATION-CEE s&apos;engage à protéger la confidentialité de vos données personnelles conformément
            au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
          </p>
          <div className="mt-6 text-white/50 text-sm">Dernière mise à jour : février 2026</div>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-14 text-slate-700 leading-relaxed">
        <Article icon={FileText} title="1. Responsable du traitement">
          Le responsable du traitement des données à caractère personnel est <strong>ECONATION-CEE</strong>,
          société immatriculée en France, agissant en qualité de mandataire administratif et financier auprès de
          l&apos;Agence Nationale de l&apos;Habitat (Anah) pour le dispositif MaPrimeRénov&apos; et auprès des obligés
          énergéticiens pour les Certificats d&apos;Économies d&apos;Énergie (CEE).
          <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm">
            <div><strong>Contact DPO :</strong> <a href="mailto:contact@econation.fr" className="text-emerald-700 underline">contact@econation.fr</a></div>
            <div className="mt-1"><strong>Adresse :</strong> Paris · Lyon · Marseille · Toulouse · Lille</div>
          </div>
        </Article>

        <Article icon={Database} title="2. Données collectées">
          Nous collectons uniquement les données strictement nécessaires à l&apos;instruction de votre dossier :
          <ul className="mt-4 space-y-2 list-disc list-inside">
            <li>Identité (nom, prénom)</li>
            <li>Coordonnées (email, téléphone, adresse)</li>
            <li>Informations logement (surface, année construction, chauffage actuel)</li>
            <li>Informations fiscales (revenu fiscal de référence, composition du foyer)</li>
            <li>Documents justificatifs (avis d&apos;imposition, CNI, justificatif de domicile)</li>
          </ul>
        </Article>

        <Article icon={ShieldCheck} title="3. Finalités du traitement">
          Vos données sont traitées exclusivement pour :
          <ul className="mt-4 space-y-2 list-disc list-inside">
            <li>Étudier votre éligibilité aux aides CEE, MaPrimeRénov&apos; et Coup de pouce Chauffage</li>
            <li>Constituer et déposer votre dossier auprès de l&apos;Anah et des obligés CEE</li>
            <li>Vous recontacter concernant votre projet de rénovation énergétique</li>
            <li>Lutter contre la fraude aux aides publiques (contrôles de cohérence et conformité)</li>
            <li>Répondre à nos obligations légales et administratives</li>
          </ul>
        </Article>

        <Article icon={Lock} title="4. Sécurité et hébergement">
          Vos données sont chiffrées en transit (TLS 1.3) et au repos. Elles sont hébergées sur des serveurs situés
          dans l&apos;Union Européenne, exclusivement accessibles aux personnes habilitées à traiter votre dossier.
          Nous appliquons les recommandations de la CNIL en matière de sécurité informatique.
        </Article>

        <Article icon={Trash2} title="5. Durée de conservation">
          <ul className="mt-4 space-y-2 list-disc list-inside">
            <li><strong>Dossiers non poursuivis :</strong> suppression automatique dans un délai maximal de 30 jours</li>
            <li><strong>Dossiers acceptés :</strong> conservation pendant la durée légale d&apos;archivage
              des dossiers d&apos;aides publiques (10 ans)</li>
            <li><strong>Prospects sans suite :</strong> 3 ans après le dernier contact</li>
          </ul>
        </Article>

        <Article icon={Award} title="6. Vos droits">
          Conformément au RGPD, vous disposez à tout moment des droits suivants :
          <ul className="mt-4 space-y-2 list-disc list-inside">
            <li>Droit d&apos;accès, de rectification et d&apos;effacement</li>
            <li>Droit à la portabilité de vos données</li>
            <li>Droit d&apos;opposition et de limitation du traitement</li>
            <li>Droit d&apos;introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-emerald-700 underline">www.cnil.fr</a>)</li>
          </ul>
          <div className="mt-5 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
            <Mail className="inline h-4 w-4 mr-1.5 -mt-0.5" />
            Pour exercer vos droits : <a href="mailto:contact@econation.fr" className="underline font-semibold">contact@econation.fr</a>
          </div>
        </Article>

        <Article icon={FileText} title="7. Cookies">
          Notre site utilise uniquement des cookies techniques strictement nécessaires au fonctionnement
          (session, préférences). Aucun cookie publicitaire ou de tracking marketing n&apos;est déposé sans votre
          consentement explicite.
        </Article>

        <Article icon={ShieldCheck} title="8. Modifications">
          La présente politique peut être mise à jour à tout moment pour refléter les évolutions légales ou
          les pratiques d&apos;ECONATION-CEE. La date de dernière mise à jour est indiquée en tête de document.
        </Article>

        <div className="pt-6 flex flex-wrap gap-3">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold transition">
            Retour à l&apos;accueil
          </Link>
          <a href="mailto:contact@econation.fr" className="inline-flex items-center gap-2 rounded-full border border-slate-300 hover:border-slate-500 text-slate-900 px-6 py-3 text-sm font-semibold transition">
            <Mail className="h-4 w-4" /> Contacter le DPO
          </a>
        </div>
      </div>
    </main>
  );
}

function Article({ icon: Ic, title, children }) {
  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-xl bg-slate-900 text-white grid place-items-center flex-shrink-0">
          <Ic className="h-5 w-5" />
        </div>
        <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
      </div>
      <div className="pl-13 text-slate-700 text-[15px] leading-[1.75]">{children}</div>
    </div>
  );
}
